import { render } from "./ByDayChart.vue?vue&type=template&id=20dbb352"
import script from "./ByDayChart.vue?vue&type=script&lang=ts"
export * from "./ByDayChart.vue?vue&type=script&lang=ts"
script.render = render

export default script